<script>
	// Stores 
	import { 
		linkMapa, 
		linkWaze, 
		linkUber,
		linkIframeMapa,
		mailAtendimento, 
		mailLocacao, 
		mailVendas,
		mailLoteamentos,
		mailCondominios,
		mailOuvidoria, 
		todosContatos,
		textSite, 
		textEndereco, 
		textAtendimento,
		textWhatsappVendas, 
		linkWhatsappVendas,
		textWhatsappLocacao, 
		linkWhatsappLocacao,
		textWhatsappCondominio, 
		linkWhatsappCondominio,
	} from '../store.js';    

	// Componentes
	import { link } from "svelte-routing";

	import Forms from "../components/Forms.svelte";  
	import PageHeader from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Fale Conosco ';

	let mensagem = GetHash('assunto') == null ? '' : GetHash('assunto');

	let contatos = $todosContatos;

	let localizacao = [
		{
			title: 'Mapa',
			icon: '<i class="fas fa-map-marked-alt color-accent"></i>',
			link: $linkMapa,
		},
		{
			title: 'Waze',
			icon: '<i class="fab fa-waze color-accent"></i>',
			link: $linkWaze,
		},
		{
			title: 'Uber',
			icon: '<i class="fab fa-uber color-accent"></i>',
			link: $linkUber,
		}
	];    

	let fields = [
		{
			title:  'Nome *',
			name:   'nome',
			required: 'required'
		},
		{
			title:  'Telefone *',
			name:   'telefone',
			required: 'required',
			classe: 'mask-telefone',
		},
		{
			title:  'Email *',
			name:   'email',
			type:   'email',
			required: 'required',
		},
		{
			title:  'Destino',
			name:   'destino',
			type:   'select',
			selectValues: [
				{
					title: 'Atendimento Geral',
					value: $mailAtendimento
				},
				{
					title: 'Aluguel',
					value: $mailLocacao
				},
				{
					title: 'Vendas',
					value: $mailVendas
				},
				{
					title: 'Condomínios',
					value: $mailCondominios
				},
				{
					title: 'Loteamentos',
					value: $mailLoteamentos
				},
				{
					title: 'Ouvidoria',
					value: $mailOuvidoria
				},
			]
		},
		{
			title:     'Mensagem *',
			name:      'mensagem',
			required:  'required',
			type:      'textarea',
			rows: 4,
			defaultValue:      mensagem
		}
	];
	const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}
Mensagem: {mensagem}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}
</script>

<PageHeader title={titlePage} buttons="" image="/assets/images/cabecalhos/interno_3.jpg" >
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<h2>Busque pelo setor que deseja</h2>
			<img src="/assets/images/icons/imgContato.png" alt="" aria-disabled="true" />
		</div>
	</div>
</PageHeader>

<div class="container text-center">
	<h3><i class="far fa-clock"></i> ATENDIMENTO: {@html $textAtendimento}</h3>
</div>
<div class="container container-short mt-40">
	<div class="grid grid-size--3 grid-size-sm--1 departamentos">
		<div class="header hidden-sm hidden-xs">Departamento</div>
		<div class="header hidden-sm hidden-xs">E-mail</div>
		<div class="header hidden-sm hidden-xs">Telefone</div>
		{#each contatos as contato, i}
			<div class="item departamento {i%2==0}">{contato.title}</div>
			<div class="item email {i%2==0}">
				<a href="mailto://{contato.email}" title="Contato via Email - {contato.phone}" target="_blank">
					{@html contato.email}
				</a> 
			</div>
			<div class="item telefone {i%2==0}">
				<a href="{contato.href}" title="Contato via Telefone - {contato.phone}" target="_blank">
					{@html contato.phone}
				</a> 
			</div>
		{/each}
	</div>
	<div class="flex flex-center flex-column mt-60 mb-40">
		<h3><i class="fas fa-map-marker-alt"></i> Endereço:<br/> {@html $textEndereco}</h3>
		<div class="flex gap-10 mt-20">
			{#each localizacao as l}
			<div class="item">
				<a href="{l.link}" target="_blank" title="{$textSite} via {l.title}">
					{@html l.icon} {l.title} 
				</a>
			</div>
			{/each}
		</div>
	</div>
</div>
<div class="mapa">
	<iframe style="width:100%;" height="500" id="gmap_canvas" src="{$linkIframeMapa}" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
</div>
<div class="container">
	<div class="text-center mt-40">
		<h3><i class="fas fa-envelope"></i> ENTRE EM CONTATO COM A GENTE</h3>
	</div>	
	<div class="flex flex-center mt-20 mb-20">
		<div class="flex-1 hidden-sm hidden-xs"></div>
		<div class="flex-1 background-gray round-all pa-30">
			<Forms destiny={''} fields={fields} {message} htmlbody={false} />
		</div>
		<div class="flex-1 hidden-sm hidden-xs"></div>
	</div>
</div>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

</style>